(function() {
  "use strict";



  angular.module("NetworkList")

    .constant('NETWORK_FILTERS', [
      {
        name: 'NetworkType',
        parameter: 'networkTypeFilter',
        type: "checkbox",
        values: [{
          key: "OFFICE",
          value: "Company",
          type: "checkbox"
        },
        {
          key: "HOME",
          value: "HomeOffice",
          type: "checkbox"
        }
        ]
      },
      {
        name: "MobilePrint",
        parameter: "airPrint",
        type: "radio",
        values: [{
          key: "airPrint",
          value: "Yes",
          state: true,
        },
        {
          key: "airPrint",
          value: "No",
          state: false,
        },
        {
          key: "airPrint",
          value: 'ClearFilter',
          state: null
        }
        ]
      },
    ])

    .controller("NetworkListController", [
      "$rootScope", "$scope", "$filter", "NetworkListService", "$location", "URLS",
      "URL_PARAMS", "$ngBootbox", "toastr", "TEMPLATE_PATHS", "$http",  "WorkstationListService",
      "WorkstationListPaging", "NetworkUnknownPropertiesTabs", "NetworkListPaging",
      "NETWORK_FILTERS", 'EventHandlerService', 'currentTenant', '$timeout', '$routeParams',
      '$window', 'CopilotService',
      function (
        $rootScope, $scope, $filter, NetworkListService, $location, URLS,
        URL_PARAMS, $ngBootbox, toastr, TEMPLATE_PATHS, $http, WorkstationListService,
        WorkstationListPaging, NetworkUnknownPropertiesTabs, NetworkListPaging,
        NETWORK_FILTERS, EventHandlerService, currentTenant, $timeout, $routeParams,
        $window, CopilotService) {

        $scope.orderByValue = "info.name";
        $scope.orderByText = "NetworkName";
        $scope.showSearchField = false;
        $scope.searchPattern = "";
        $scope.checkAllCheckboxes = false;
        $scope.networkListService = NetworkListService;
        $scope.helpCaption = "HelpNetworksPage";
        $scope.eventHandlerService = EventHandlerService;
        $scope.migrateNetwork = null;

        // PAGING CONFIG
        $scope.noDataMessage = "NoSearchResultItem";
        $scope.searchInputFieldHolderFocusKey = "searchInputFieldHolderFocusKey";
        $scope.searchInputPlaceholderText = "Search";
        $scope.networkUnknownPropertiesTabs = NetworkUnknownPropertiesTabs;
        $scope.networkListPaging = new NetworkListPaging();
        $scope.migrateNetworkListPaging = new NetworkListPaging();
        $scope.requestType = 'GET';
        $scope.me = null;
        var initialListRequest = true;
        $scope.windowWidth = $window.innerWidth;
        $scope.loadingPage = true;


        (function () {
          detectGlobalSettings();
          initEventHandler();
          fulfillCopilotRequest();
        }())

        function fulfillCopilotRequest() {
           if (CopilotService.state.requestedAction.responseType !== 'NETWORKS') {
            return;
          }
            const pattern = CopilotService.useNetworkName();
            if (pattern) {
                $scope.$applyAsync(() => {
                  $scope.searchPattern = pattern;
                });
              }
        }

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        }


        function detectGlobalSettings () {
          $scope.globalSetting = currentTenant.info.clientMigratePrintQueues;
        }


        $scope.$watch(function() {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;


            var networkFilters = angular.copy(NETWORK_FILTERS);
            initFilters(networkFilters);
          }
        })


        function initFilters(networkFilters) {
          $scope.networkListPaging.pagingCriteria.page = $routeParams['networkPage'] > 1 ? $routeParams['networkPage'] - 1 : 0;
          $scope.filtersList = networkFilters;
        }


        function reportWindowSize() {
          $scope.windowWidth = $window.innerWidth;
          $scope.$apply();
        }
        window.onresize = reportWindowSize;


        $scope.changeOrderByValue = function(textValue) {
          if ($scope.reverse) {
            $scope.reverse = false;
            $scope.networkListPaging.pagingCriteria.direction = 'ASC';
            $scope.networkListPaging.pagingCriteria.sort = textValue;
          } else {
            $scope.reverse = !$scope.reverse;
            $scope.networkListPaging.pagingCriteria.direction = 'DESC';
            $scope.networkListPaging.pagingCriteria.sort = textValue;
          }
          $scope.getNetworkListPaged();
        };


        $scope.getNetworkListPaged = function(skipResetScroll) {
          if (!skipResetScroll) {
            angular.element('.px-scrollbar-scroll').scrollTop(0);
          }

          $scope.eventHandlerService.queue.stopQueue();
          $scope.loadingPage = true;
          NetworkListService.getNetworkListPagedByPost($scope.networkListPaging).then(function(networkContainer) {

            $scope.loadingPage = false;

            if (initialListRequest || $scope.networkListPaging.pagingCriteria.page === 0) {
              initialListRequest = false;
              $location.path($location.path(), false).search({ networkPage: parseInt($scope.networkListPaging.pagingCriteria.page) + 1 }).replace();
            } else {
              $location.path($location.path(), false).search({ networkPage: parseInt($scope.networkListPaging.pagingCriteria.page) + 1 })
            }

            $scope.networkContainer = angular.copy(networkContainer);
            if ($scope.eventHandlerService.getControllerScope() !== 'networkList') {
              $scope.eventHandlerService.setControllerScopeData('networkList', $scope.networkContainer.list)
            } else {
              refreshEventHandler();
            }
          }).catch(function(error) {});
        };


        $scope.getNextPage = function functionName(showPrevious) {
          if (showPrevious) {
            if ($scope.networkListPaging.pagingCriteria.page > 0) {
              $scope.networkListPaging.pagingCriteria.page--;
            }
          } else {
            if ($scope.networkListPaging.pagingCriteria.page + 1 < $scope.networkContainer.page.totalPages) {
              $scope.networkListPaging.pagingCriteria.page++;
            }
          }
          $scope.getNetworkListPaged();
        }

        function getNetworkByUrl (networkUrl) {
          $scope.eventHandlerService.queue.stopQueue();
          NetworkListService.getNetworkModelByUrl(networkUrl).then(function(network) {
            for (var i = 0; i < $scope.networkContainer.list.length; i++) {
              if ($scope.networkContainer.list[i].info._links.self.href === network.info._links.self.href) {
                $scope.networkContainer.list[i].info = network.info;
              }
            }
            refreshEventHandler();
          }).catch(function() {
            refreshEventHandler();
          })
        }

        function refreshEventHandler() {
          $scope.eventHandlerService.refreshScopeData('networkList', $scope.networkContainer.list).then(function(){
            $scope.eventHandlerService.queue.setState('idle');
          }).catch(function(error) {});
        }


        $scope.addNewNetworkCallback = function (dialogResult) {
          const newNetworkName = dialogResult.value;
          if (newNetworkName && newNetworkName.length > 0) {
            NetworkListService.addNewNetwork(newNetworkName).then(function () {
              $scope.clearPopups();
            }).catch(function () {
              $scope.clearPopups();
            })
          } else {
            $scope.clearPopups();
            toastr.error($filter("translate")("EnterNetworkName"));
          }
        };

        $scope.clearPopups = function () {
          $scope.addNewNetworkPopupObject = null;
          $scope.addNewNetworkConfiguration = null;
        };

        $scope.addNewNetwork = function (newNeworkName) {

          $scope.addNewNetworkConfiguration = {
            inputDataObject: [{
              label: 'NetworkName',
              placeholder: 'NetworkName',
              type: 'input',
              keyIdentifier: 'networkName',
              value: newNeworkName,
              focus: true,
              allowEmptyInput: false
            }]
          };

          $scope.addNewNetworkPopupObject = {
            dimensions: { height: 260, width: 560 },
            pointerPosition: 'none',
            relativePosition: 'none',
            context: 'selectNetwork',
            type: 'SIMPLE_INPUT',
            title: 'AddNewNetwork',
            confirmText: 'Ok',
            cancelText: 'Cancel',
            clickOutsideToClose: false
          };

          $timeout(function() {
            angular.element('popup-generel-purpose input').focus();
          }, 500);

        };


        $scope.setMigrateNetwork = function (network) {
          $scope.migrateNetwork = network;
          if (!$scope.migrateNetwork) {
            document.getElementsByClassName('delete-network-btn-hook')[0].disabled = true;
          } else {
            document.getElementsByClassName('delete-network-btn-hook')[0].disabled = false;
          }
        }


        $scope.toggleMigratePrinters = function (checkboxValue) {
          $scope.migratePrinters.checkbox.value = checkboxValue;
          if (!checkboxValue) {
            $scope.migrateNetwork = null;
            document.getElementsByClassName('delete-network-btn-hook')[0].disabled = false;
          } else {
            $scope.migrateNetwork = null;
            document.getElementsByClassName('delete-network-btn-hook')[0].disabled = true;
          }
        }


        $scope.deleteNetwork = function(network) {
          $scope.network = network;
          var excludedNetwork = [];
          excludedNetwork.push(network.info._links.self.href);
          $scope.migrateNetwork = null;
          $scope.migratePrinters = {
            checkbox: {
              value: true
            }
          }

          $scope.migrateNetworkListPaging.pagingCriteria.excludeNetworkIds = excludedNetwork;
          $scope.networkPaginationConfiguration = {
            paginationObject: $scope.migrateNetworkListPaging,
            placeholderText: 'Search',
            service: 'NetworkListService',
            contentHeight: 463,
          };


          var deleteNetworkDialogOptions = {
            scope: $scope,
            templateUrl: TEMPLATE_PATHS.DELETE_NETWORK_TEMPLATE_PATH,
            buttons: {
              warning: {
                className: 'btn-default',
                label: $filter('translate')('Cancel')
              },
              success: {
                className: 'btn-primary delete-network-btn-hook',
                idName: 'numse',
                label: $filter('translate')('Ok'),
                disable: true,
                callback: function() {
                  NetworkListService.deleteNetwork(network, null, $scope.migrateNetwork).then(function() {
                    toastr.success($filter("stringular")($filter("translate")("NetworkDeleted"), network.info.name));
                  }).catch(function(error) {});
                }
              }
            }

          }
          $ngBootbox.customDialog(deleteNetworkDialogOptions);
            $timeout(function() {
            document.getElementsByClassName('delete-network-btn-hook')[0].disabled = true;
          }, 100)
        };



        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // EVENTHANDLER
        ////////////////////////////////////////////
        var NETWORKLIST_listener = $rootScope.$on('networkList', function(name, data) {
          switch (data.operation) {
            case 'refreshList':
              $scope.getNetworkListPaged(true);
              break;
            case 'replaceItem':
              getNetworkByUrl(data.itemId);
              break;
          }
        })

        $scope.$on('$destroy', function() {
          NETWORKLIST_listener();

          // Be sure any bootbox dialogs are closed
          $ngBootbox.hideAll();
        });


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        $scope.openListMenu = function (event, network) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            $scope.closeListMenu();
            $scope.listMenuContext = network;
            $scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'networkList',
              scrollContainerId: 'NetworkScrollContainer'
            }
            $scope.$apply();
          }, 50)
        }

        $scope.closeListMenu = function (network, action) {
          $scope.listMenuContext = null;
          $scope.listMeta = null;

          switch (action) {
            case 'DELETE_NETWORK':
              $scope.deleteNetwork(network);
              break;
          }
        }

      }
    ])
})();
